import React from "react";
import { HERO } from "../mock";

function Eyebrow({ text, testId = "section-eyebrow" }) {
  return (
    <div className="section-eyebrow inline-flex items-center gap-3">
      <span className="section-eyebrow-line h-px w-10" />
      <span data-testid={testId} className="section-eyebrow-label font-mono-label">
        {text}
      </span>
      <span className="section-eyebrow-line h-px w-10" />
    </div>
  );
}

export default function Hero() {
  return (
    <section
      data-testid="hero-section"
      className="relative isolate pt-36 md:pt-44 pb-14 md:pb-20 overflow-hidden"
    >
      <div aria-hidden className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="orb orb-blue -top-40 -left-40" />
        <div className="orb orb-cyan top-1/3 -right-32" />
        <div className="orb orb-soft bottom-0 left-1/4" />
        <div
          className="absolute inset-0"
          style={{
            background:
              "radial-gradient(at 50% 0%, rgba(0,168,232,0.12), rgba(255,255,255,0) 60%)",
          }}
        />
      </div>

      <div className="relative mx-auto max-w-4xl px-6 md:px-10 text-center">
        <div className="reveal">
          <Eyebrow text={HERO.eyebrow} testId="hero-eyebrow" />
        </div>
        <h1
          className="hero-eyebrow-title-gap font-display leading-[1.02] reveal"
          style={{ fontSize: "clamp(2.5rem, 6vw, 5rem)", animationDelay: "0.1s", color: "#201850" }}
        >
          {HERO.titleTop}
          <br />
          <span className="wordmark">{HERO.titleBottom}</span>
        </h1>
        <div
          className="responsive-copy mt-7 max-w-3xl mx-auto space-y-4 leading-relaxed reveal"
          style={{ animationDelay: "0.2s", fontSize: "clamp(1rem, 1.35vw, 1.2rem)", color: "rgba(32,24,80,0.78)" }}
        >
          {HERO.paragraphs.map((p, i) => (
            <p key={i} data-testid={`hero-body-${i + 1}`}>{p}</p>
          ))}
        </div>
      </div>
    </section>
  );
}

export { Eyebrow };
